import { SubjectBannerType } from './models';

export const queryKeys = {
  USE_TOPIC_TEST: 'use-topic-tests',
  USE_TOPIC_TEST_BY_ID: 'use-topic-tests-by-id',
  USE_FINISH_TEST: 'use-finish-test',
  USE_MY_RESULT: 'use-my-result',
  USE_TOPIC_TEST_INFO: 'use-topic-test-info',
  USE_TOPIC_TEST_QUIZ: 'use-topic-test-quiz'
};

export const subjectBannerMap: Record<string, SubjectBannerType> = {
  'ingliz-tili': {
    targetUrl: 'https://t.me/rising_zone',
    goalId: 'rising_zone',
    desktop: '/images/rising-zone-vertical-banner.webp',
    mobile: '/images/rising-zone-inside-card.webp',
    insideCardBanner: '/images/rising-zone-inside-card.webp'
  },
};
